module.exports = __webpack_public_path__ + "img/1538220131.9ffa13e7.jpg";